module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "small-sec-voucher",
    attrs: {
      "for": 'card-no' + _vm.voucher.cardNo
    },
    on: {
      "click": function($event) {
        return _vm.selectVoucher(_vm.voucher)
      }
    }
  }, [_c('div', {
    staticClass: "small-voucher-content"
  }, [_c('ul', {
    staticClass: "small-voucher-field"
  }, [_c('li', [_c('span', {
    staticClass: "small-voucher-desc"
  }, [_vm._v(_vm._s(_vm.voucher.holderName) + "：")]), _vm._v(_vm._s(_vm._f("cardType")(_vm.voucher.cardType)) + "\n      ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "small-voucher-desc"
  }, [_vm._v("卡号：")]), _vm._v(_vm._s(_vm._f("dotted")(_vm.voucher.cardNo)) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "small-voucher-radio"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19ad339d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/voucher/VoucherItemSmall.vue
// module id = 794
// module chunks = 0